import React from 'react';
import { Typography, Divider } from 'antd';
import { Link } from 'react-router-dom';
import { LinkedinOutlined, FacebookOutlined, InstagramOutlined, XOutlined } from '@ant-design/icons';
import { FOOTER_COLUMNS, SOCIAL_LINKS } from '../../config/siteLinks';
import './Footer.css';

const { Title } = Typography;

const Footer: React.FC = () => {
  return (
    <>
      <footer className="site-footer">
        <div className="footer-content">
          <div className="footer-grid">
            <div className="footer-brand">
              <Title level={4} className="footer-brand__name">enpropeL</Title>
              <p className="footer-brand__tag">
                Bridging Students with Industry.
                <br />
                Building Careers for the Future.
              </p>
              <div className="social-links">
                <a href={SOCIAL_LINKS.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><LinkedinOutlined /></a>
                <a href={SOCIAL_LINKS.x} target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)"><XOutlined /></a>
                <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><InstagramOutlined /></a>
                <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FacebookOutlined /></a>
              </div>
            </div>
            {FOOTER_COLUMNS.map((column) => (
              <div className="footer-col" key={column.title}>
                <h5>{column.title}</h5>
                <ul className="footer-links">
                  {column.links.map((link) => (
                    <li key={`${column.title}-${link.label}`}>
                      <Link to={link.to}>{link.label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <Divider className="footer-divider" />
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} enpropeL. All rights reserved.</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
